import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorTelemetry } from "./lib/errorTelemetry";

// Initialize global error telemetry before React mounts
initErrorTelemetry();

// Clean up the static skeleton so it doesn't interfere after React mounts
document.getElementById("initial-skeleton")?.remove();

createRoot(document.getElementById("root")!).render(<App />);
